<div class="driver-modal">
  <div class="sec_head">
    <h2>{{ modalTitle | translate }}</h2>
  </div>
  <div class="modal-body">
    <form [formGroup]="driverDocumentForm" (ngSubmit)="submitDoc()">
      <div class="form_feilds gap_m">
        <div class="form_group">
          <mat-label class="required">
            {{ 'DocumentName' | translate }}
          </mat-label>
          <mat-form-field appearance="fill">
            <input
              matInput
              formControlName="documentName"
              placeholder="{{ 'DocumentName' | translate }}"
              class="form_control" 
            />
            <mat-error *ngIf="driverDocumentForm.get('documentName')?.hasError('required')">
              {{ 'This field is required' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        
        <div class="form_group">
          <mat-label>{{ 'DocumentType' | translate }}</mat-label>
          <mat-form-field>
            <mat-select
              formControlName="documentType"
              placeholder="{{ 'SelectDocumentType' | translate }}"
              class="form_control"
            >
              <mat-option value="Driver">{{ 'Driver' | translate }}</mat-option>
              <mat-option value="Vehicle">{{ 'Vehicle' | translate }}</mat-option>
            </mat-select>
            <mat-error *ngIf="driverDocumentForm.get('documentType')?.hasError('required')">
              {{ 'This field is required' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        
        <div class="form_group">
          <mat-label>{{ 'RequireType' | translate }}</mat-label>
          <mat-form-field>
            <mat-select
              formControlName="requiredType"
              placeholder="{{ 'RequireType' | translate }}"
              class="form_control"
            >
              <mat-option value="mandatory">{{ 'Mandatory' | translate }}</mat-option>
              <mat-option value="optional">{{ 'Optional' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        
        <div class="form_group">
          <mat-label>{{ 'Require' | translate }}</mat-label>
          <mat-form-field>
            <mat-select
              formControlName="required"
              placeholder="{{ 'Require' | translate }}"
              class="form_control"
            >
              <mat-option [value]="true">{{ 'Yes' | translate }}</mat-option>
              <mat-option [value]="false">{{ 'No' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        
        <div class="form_group">
          <mat-label>{{ 'DocumentNumberRequire' | translate }}</mat-label>
          <mat-form-field>
            <mat-select
              formControlName="documentNumberRequired"
              placeholder="{{ 'DocumentNumberRequire' | translate }}"
              class="form_control"
            >
              <mat-option [value]="true">{{ 'Yes' | translate }}</mat-option>
              <mat-option [value]="false">{{ 'No' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        
        <div class="form_group">
          <mat-label>{{ 'IssueDateRequire' | translate }}</mat-label>
          <mat-form-field>
            <mat-select
              formControlName="issueDateRequired"
              placeholder="{{ 'IssueDateRequire' | translate }}"
              class="form_control"
            >
              <mat-option [value]="true">{{ 'Yes' | translate }}</mat-option>
              <mat-option [value]="false">{{ 'No' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        
        <div class="form_group">
          <mat-label>{{ 'ExpiryDateRequire' | translate }}</mat-label>
          <mat-form-field>
            <mat-select
              formControlName="expiryDateRequired"
              placeholder="{{ 'ExpiryDateRequire' | translate }}"
              class="form_control"
            >
              <mat-option [value]="true">{{ 'Yes' | translate }}</mat-option>
              <mat-option [value]="false">{{ 'No' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      
      <div class="submit_btn">
        <button 
          class="btnn btn_secondary" 
          type="button"
          (click)="onCancel()"
        >
          {{ 'Cancel' | translate }}
        </button>
        <button 
          class="btnn btn_primary" 
          type="submit"
          [disabled]="!driverDocumentForm.valid"
        >
          {{ (isEdit ? 'Update' : 'Submit') | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
